/**
 * @fileoverview Константы для работы с системой mention
 * @description Централизованное хранение всех констант, связанных с mention-механизмом
 */

/**
 * Типы mention узлов
 * @readonly
 * @enum {string}
 */
export const MENTION_TYPES = {
  /** Обычное поле из внешнего сервиса */
  SERVICE: "service",
  /** Кастомное поле, определенное пользователем */
  CUSTOM: "custom",
  /** Поле с данными нотариуса */
  NOTARY: "notary",
  /** Число прописью (calc) */
  NUMBER_TO_WORDS: "number_to_words",
};

/**
 * Коды специальных сервисов
 * @readonly
 * @enum {string}
 */
export const SPECIAL_SERVICE_CODES = {
  /** Данные нотариуса */
  NOTARY: "notary",
  /** Ручной ввод данных */
  MANUAL_INPUT: "manual_input",
  /** Внутренние базы данных */
  INTERNAL_DATABASES: "internal_databases",
};

/**
 * Разделитель для формирования составных ключей mention
 * @constant {string}
 */
export const MENTION_KEY_SEPARATOR = "_";

/**
 * Префикс для отображения mention в документе
 * @constant {string}
 */
export const MENTION_DISPLAY_PREFIX = "$";

/**
 * Типы данных из ответов сервисов
 * @readonly
 * @enum {string}
 */
export const RESPONSE_DATA_TYPES = {
  PRIMITIVE: "primitive",
  OBJECT: "object",
  ARRAY: "array",
  DICTIONARY: "dictionary",
};

/**
 * Названия полей для определения справочников
 * @constant {string[]}
 */
export const DICTIONARY_FIELD_NAMES = ["name", "name_ru", "name_kz", "name_en"];

/**
 * Разрешённые ключи в объекте-справочнике.
 * Если объект имеет name*-поле, но содержит ключи ВНЕ этого whitelist —
 * это не справочник, а структурированные данные (например, leader{name, iin, sur_name, ...}).
 * @constant {string[]}
 */
export const DICTIONARY_ALLOWED_KEYS = [
  "name",
  "name_ru",
  "name_kz",
  "name_kk",
  "name_en",
  "code",
  "id",
];

/**
 * Локали для локализации данных
 * @readonly
 * @enum {string}
 */
export const LOCALES = {
  RUSSIAN: "ru",
  KAZAKH: "kz",
  ENGLISH: "en",
};

/**
 * Режимы работы редактора
 * @readonly
 * @enum {string}
 */
export const EDITOR_MODES = {
  /** Режим редактирования */
  EDIT: "edit",
  /** Режим просмотра */
  VIEW: "view",
  /** Режим предпросмотра с подстановкой значений */
  PREVIEW: "preview",
};
